import { render, staticRenderFns } from "./SlSwitchButton.vue?vue&type=template&id=023bf67d&"
import script from "./SlSwitchButton.vue?vue&type=script&lang=js&"
export * from "./SlSwitchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports